/**
 * Global force-update gate.
 *
 * Set by the app-updater when the server advertises a `minNativeVersion`
 * higher than the running native app's version. Read by the router guard
 * in routes-user.ts to redirect all navigation to the force-update screen.
 *
 * One-way: once set, stays set until the app restarts. The intent is that
 * the user must install a newer APK/IPA to escape this state.
 */

let _forceUpdateActive = false;

export function setForceUpdateActive(): void {
  _forceUpdateActive = true;
}

export function isForceUpdateActive(): boolean {
  return _forceUpdateActive;
}
